import {defineComponent, PropType} from "vue";
import {LoaderSize} from "../../enums/LoaderSize";

export const Loader = defineComponent({
    props: {
        isFullscreen: {
            default: false,
            type: Boolean,
        },
        isStretch: {
            default: false,
            type: Boolean,
        },
        size: {
            type: String as PropType<LoaderSize>,
        },
    },
    template: `
      <div :class="[
        'loader', size ? 'loader_size_' + size : '', 
        {
          'loader_fullscreen': isFullscreen, 
          'loader_stretch': isStretch,
        }
      ]">
        <div></div><div></div><div></div><div></div>
      </div>
    `,
})